<template>
  <div id="product-documents-standard-clause-edit">

    <vs-alert color="danger" title="Standard Clause Document Not Found" :active.sync="not_found">
      <span>Standard Clause Document record with id: {{ id }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'standard-clause.list'}" class="text-inherit underline">All
        Standard Clause Documents</router-link>
      </span>
    </vs-alert>

    <standard-clause-form v-if="model" v-model="model" ref="form" :forms="formReferences" :apiModel="apiModel"/>

    <div class="vx-row" v-if="model">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              :disabled="loading"
              @click="$router.push({ name: 'standard-clause.list' })"
              class="ml-4 mt-2"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              :disabled="loading"
              @click="save"
              class="ml-auto mt-2"
              color="light"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import StandardClauseForm from "@/views/pages/product-documents/standard-clause/StandardClauseForm";
import ProductDocumentEditMixin from "@/components/mixins/ProductDocumentEditMixin";

export default {
  name: "StandardClauseEdit",
  components: {
    StandardClauseForm
  },
  mixins: [ProductDocumentEditMixin],
  data() {
    return {
      apiModel: 'productStandardClause',
    };
  },
};
</script>

<style scoped>

</style>
